import React, { createContext, useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Snackbar,
  Stack,
} from "@mui/material";
import Select from "react-select";
import { useContext } from "react";
import { InvoiceTableContext } from "./Logistic";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { useState } from "react";
import AgGridTable from "../utilities/AgGridTable";
import Invoice from "./Invoice";
import customStyles from "app/shared-components/SelectCustomStyle";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import { toast } from "react-toastify";
import CloseIcon from '@mui/icons-material/Close';
import InvoiceEditor from "./InvoiceEditor";

const invoiceTypeOptions = [
  { value: "Custom Invoice", label: "Custom Invoice" },
  { value: "Commercial Invoice", label: "Commercial Invoice" },
];

// const InVoiceContext = createContext();
const InvoiceEditorContext = createContext();

const InvoiceTable = ({ selectedLogisticRows }) => {
  const ordersUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orders}`;
  const generateInvoiceUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.generateInvoice}`;

  const [showInvoiceTable, setShowInvoiceTable] =
    useContext(InvoiceTableContext);
  const [rowData, setRowData] = useState();
  // const [openSnack, setOpenSnack] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);
  const [invoiceType, setInvoiceType] = useState(null);
  const [selectedInvoiceRows, setSelectedInvoiceRows] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [saveDisable, setsaveDisable] = useState(true);
  const [updateRowData, setUpdateRowData] = useState([]);
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [genInvoice , setgenInvoice] = useState([])
  const gridRef = useRef();
  const navigate = useNavigate();
  const [columnCreateDefs, setColumnCreateDefs] = useState([
    { field: "abNumber", enableRowGroup: true, headerName: "AB Number", editable: false, },
    { field: "description", enableRowGroup: true, editable: false, },
    { field: "hsCode", enableRowGroup: true, headerName: "HS Code", editable: false, },
    { field: "country", enableRowGroup: true, headerName: "Country Of Origin", editable: false, },
    { field: "quantity", enableRowGroup: true, headerName: "Qty" },
    { field: "noOfPacks", enableRowGroup: true },
    { field: "invoiceAmount", enableRowGroup: true, headerName: "Amount" },
  ]);


  useEffect(() => {
    selectedLogisticRows.map((row) => setRowData(row.orders));
  }, [selectedLogisticRows]);

  const onSelectionChanged = (params) => {
    setSelectedInvoiceRows(params.api.getSelectedRows());
  };

  const handleInvoiceTypeChange = (data) => {
    setInvoiceType(data.label);
  };

  const handleClose = () => {
    setShowInvoiceTable(false);
    setInvoiceType(null);
  };
  const autoSizeAll = useCallback(
    (value) => {
      const allColumnIds = [];
      gridRef.current.columnApi.getColumns().forEach((column) => {
        allColumnIds.push(column?.getId());
      });
      gridRef.current.columnApi.autoSizeColumns(allColumnIds, value);
    },
    [rowData]
  );

  const onGridReady = useCallback((params) => {
    setGridApi(params);
    var columnToolPanel = gridRef.current.api.getToolPanelInstance("columns");
    columnToolPanel.expandColumnGroups();
    // autoSizeAll(false);
  }, []);

  // const onBtAdd = useCallback((event) => {
  //   const data = event.node.data;
  //   const newRow = {};
  //   const newRowDate = gridRef.current.api.applyTransaction({
  //     add: [newRow],
  //   });
  //   const RowIndex = newRowDate.add[0].rowIndex;
  //   // updateData.splice(RowIndex, 0, newRow);
  //   gridRef.current.api.refreshCells();

  //   setTimeout(() => {
  //     gridRef.current.api.setFocusedCell(RowIndex, "abNumber");
  //     gridRef.current.api.startEditingCell({
  //       rowIndex: RowIndex,
  //       colKey: "abNumber",
  //     });
  //   }, 800);
  // }, []);
  // const onBtStartEditing = useCallback((event) => {
  //   const index = event.node.rowIndex;
  //   gridRef.current.api.setFocusedCell(index, "abNumber");
  //   gridRef.current.api.startEditingCell({
  //     rowIndex: index,
  //     colKey: "abNumber",
  //   });
  // }, []);

  // const onBtDeleteRow = useCallback(
  //   (event) => {
  //     const selectedRow = gridApi.api.getSelectedRows();
  //     rowData.splice(event.node.rowIndex, 1);
  //     gridRef?.current?.api.applyTransaction({ remove: selectedRow });
  //     selectedRow.map(async (row) => {
  //       // await OAuthService.deleteData(url, row.id);
  //     });
  //   },
  //   [gridApi, rowData]
  // );

  // const getContextMenuItems = (event) => {
  //   const data = event.node.data;
  //   var result = [
  //     {
  //       name: "Add Row",
  //       icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
  //       action: () => {
  //         onBtAdd(event);
  //       },
  //     },
  //     {
  //       name: "Edit Row",
  //       icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
  //       action: () => {
  //         onBtStartEditing(event);
  //       },
  //     },
  //     {
  //       name: "Delete Row",
  //       // disabled: requireDocument.includes(data.documentName),
  //       icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
  //       action: () => {
  //         onBtDeleteRow(event);
  //       },
  //     },
  //   ];
  //   return result;
  // };

  const onRowValueChanged = useCallback(
    async (event) => {
      let data = event.data;
      const model = {
        id: data.id,
        quantity: data.quantity,
        noOfPacks: data.noOfPacks,
        invoiceAmount: data.invoiceAmount,
      };
      if (
        updateRowData.filter((data) => data.id === event.data.id).length > 0
      ) {
        const updatedData = updateRowData.map((item) => {
          if (item.id === event.data.id) {
            item.quantity = data.quantity;
            item.noOfPacks = data.noOfPacks;
            item.invoiceAmount = data.invoiceAmount;
          }
          return item;
        });
        setUpdateRowData(updatedData);
      } else {
        setUpdateRowData([...updateRowData, model]);
      }
    },
    [updateRowData]
  );
  const handleSnackClose = () => {
    setSnackState(false);
}

  const handleSubmit = async () => {
    // setCheckSubmit(true);
    try {
      updateRowData.map(async (row) => {
        await OAuthService.updateData(ordersUrl, row.id, row);
      });
      setSuccessMsg("Data Updated Successfully");
      setSnackState(true);
      setTimeout(() => {
        setSnackState(false);
      }, 2000);
    } catch (error) {
      console.log(error.message);
      return;
    }
  };

  const genrateInvoice = async () => {
    const id = selectedLogisticRows[0].id;
    try {
       const res = await OAuthService.getEditData(generateInvoiceUrl, id, "no");
       if(res.status === 200){
         setShowInvoice(true);
         setgenInvoice(res.data);
       }
    } catch (error) {
      console.log(error.message);
      return;
    }
  }

  useEffect(() => {
    if(updateRowData.length > 0){
      setsaveDisable(false)
    }
  }, [updateRowData])

  return (
    <>
      <Dialog
        open={showInvoiceTable}
        onClose={() => setShowInvoiceTable(false)}
        fullWidth={true}
        maxWidth={"lg"}
      >
        <DialogTitle>
          <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
            <span>Document Creation</span>
            <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
              <Button onClick={() => handleClose()}>
                <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
              </Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContent>
            <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-between space-x-8 mb-10">
              <Stack className="w-3/12">
                <label>Select Invoice Type</label>
                <Select
                  className="mb-16"
                  name="invoiceType"
                  value={
                    invoiceType &&
                    invoiceTypeOptions &&
                    invoiceTypeOptions.filter(
                      (obj) => invoiceType === obj.value
                    )
                  }
                  onChange={handleInvoiceTypeChange}
                  options={invoiceTypeOptions}
                  styles={customStyles()}
                />
              </Stack>
              <div>
                <Button
                  className="mr-16"
                  type="submit"
                  onClick={handleSubmit}
                  variant="contained"
                  color="warning"
                  disabled={saveDisable}
                >
                  <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                </Button>

                <Button
                  variant="contained"
                  color="warning"
                  disabled={invoiceType ? false : true}
                  onClick={() => {
                    genrateInvoice();                    
                    // navigate(`/logistics-invoice/${selectedLogisticRows[0].id}`);
                  }}
                >
                  Generate Invoice
                </Button>
              </div>
            </div>

            <div className="h-[400px]">
              <AgGridTable
                rowData={rowData}
                gridRef={gridRef}
                columnDefs={columnCreateDefs}
                onSelectionChanged={onSelectionChanged}
                editable={true}
                editType={"fullRow"}
                // getContextMenuItems={getContextMenuItems}
                onRowValueChanged={onRowValueChanged}
                onGridReady={onGridReady}
              />
            </div>
          </DialogContent>
        </DialogContent>
      </Dialog>

      {/* <InVoiceContext.Provider
        value={[showInvoice, setShowInvoice, invoiceType, selectedInvoiceRows]}
      >
        <Invoice />
      </InVoiceContext.Provider> */}
      <InvoiceEditorContext.Provider
        value={[showInvoice, setShowInvoice, invoiceType, selectedInvoiceRows, genInvoice, selectedLogisticRows]}
      >
        <InvoiceEditor />
      </InvoiceEditorContext.Provider>

      <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={snackState}
                autoHideDuration={6000}
                disableWindowBlurListener={true}
                onClose={handleSnackClose}
                message={successMsg}
                sx={{ top: '60px !important' }}
                action={(<>
                    <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={handleSnackClose}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </>)}
            />
    </>
  );
};

export default InvoiceTable;
export {  InvoiceEditorContext };
